import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import {
  card,
  cardBody,
  cardContainer,
  cardFooter,
  styledContainer,
  subTitle,
  title,
} from "./TeaserList.module.scss";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <Container className={styledContainer} fluid="sm">
      {props.children}
    </Container>
  );
};

export const Teaser: React.FC<any> = (props) => {
  return (
    <div className={styledContainer}>
      <Row className="justify-content-md-center">
        <Col className="text-center">
          {props.field_subtitle && (
            <div className={subTitle} id={`teaser-block-subtitle`}>
              {props.field_subtitle}
            </div>
          )}
          {props.field_title ? (
            props?.titelNodeType === "h2" ? (
              <h2 className={title} id={`teaser-block-title`}>
                {props.field_title}
              </h2>
            ) : (
              <h3 className={title} id={`teaser-block-title`}>
                {props.field_title}
              </h3>
            )
          ) : null}
          {props.field_description && (
            <p
              className="description"
              id={`teaser-block-desc`}
              dangerouslySetInnerHTML={{ __html: props.field_description }}
            />
          )}
          {props.field_link && (
            <div className="text-center text-uppercase pb-4">
              <Link
                to={props.field_link.url}
                state={{ defaultSearch: true }}
                className="btn btn-primary ps-5 pe-5"
              >
                {props.field_link.title}
              </Link>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export const TeaserCards: React.FC<any> = (props) => {
  let linkType = null;
  const linkPrefix = props.teaser.field_link
    ? props.teaser.field_link.uri.split(":")[0]
    : null;
  if (linkPrefix) {
    linkType =
      linkPrefix === "http" || linkPrefix === "https" ? "external" : "internal";
  }
  const image = props.teaser.relationships.media?.relationships.image
    ? getImage(
        props.teaser.relationships.media.relationships.image.gatsbyImage as any
      )
    : null;
  return (
    <Col lg={props.columnWidth} key={props.teaser.id}>
      <div className={cardContainer} id={`teaser-${props.teaserId}`}>
        <Card className={card}>
          {!!image && typeof image != "string" && (
            <Card.Img
              as={GatsbyImage}
              image={image}
              alt={props.teaser.field_title}
              variant="top"
            />
          )}
          <Card.Body className={cardBody}>
            <h4 className="mb-3" data-testid="field-title" id={`teaser-title`}>
              {props.teaser.field_title}
            </h4>
            <div
              className="description"
              id={`teaser-desc`}
              dangerouslySetInnerHTML={{
                __html: props.teaser.field_description,
              }}
            />
          </Card.Body>
          <Card.Footer className={cardFooter}>
            {linkType && linkType === "internal" && (
              <Link
                to={props.teaser.field_link.url}
                state={{ defaultSearch: true }}
                className="teaser-link"
                id={`teaser-list-internal-link`}
                style={
                  props.backgroundColor
                    ? { borderBottomColor: props.backgroundColor }
                    : {}
                }
              >
                {props.teaser.field_link.title}
              </Link>
            )}
            {linkType && linkType === "external" && (
              <a
                href={props.teaser.field_link.url}
                className="teaser-link"
                id={`teaser-list-external-link`}
                rel="noopener norefferer noreferrer"
                target="_blank"
                style={
                  props.backgroundColor
                    ? { borderBottomColor: props.backgroundColor }
                    : {}
                }
              >
                {props.teaser.field_link.title}
              </a>
            )}
          </Card.Footer>
        </Card>
      </div>
    </Col>
  );
};
